$(document).ready(function () {
    // automatically submit ref works form
    var refworks = $('form#refworks');
    if (refworks.length) {
        refworks.submit();
    }
});
